import { render, staticRenderFns } from "./LinkifyText.vue?vue&type=template&id=68394afb&scoped=true&lang=pug&"
import script from "./LinkifyText.vue?vue&type=script&lang=js&"
export * from "./LinkifyText.vue?vue&type=script&lang=js&"
import style0 from "./LinkifyText.vue?vue&type=style&index=0&id=68394afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68394afb",
  null
  
)

export default component.exports